import * as Actions from './actions';

const ActionCreators = {

  ...Actions,
};

export default ActionCreators;
